export class NavController {
  private elOverlay: HTMLDivElement;

  constructor() {
    this.elOverlay = document.getElementById( 'overlay-nav-home' ) as HTMLDivElement;
  }

  public onClickOverlayShow( e: MouseEvent ): void {
    if ( !this.elOverlay.classList.contains( 'show' ) ) {
      this.elOverlay.classList.add( 'show' );
    }
  }

  public onClickOverlayClose( e: MouseEvent ): void {
    this.elOverlay.classList.remove( 'show' );
  }
}
